import Coordenates from "./Coordenates";
import { Position, LinkedPosition } from "../../types/Game";
import * as _ from "lodash";

const getAll = (): Array<Position> => {
  return Coordenates.getAllCoordenates();
};

const get = (index: number): Position | null => {
  return _.get(Coordenates.getAllCoordenates(), index, null);
};

const getFirst = (): Position | null => {
  const fisrt = _.first(Coordenates.getAllCoordenates());
  return fisrt ? fisrt : null;
};

const getLast = (): Position | null => {
  const last = _.last(Coordenates.getAllCoordenates());
  return last ? last : null;
};

const getLinked = (index: number): LinkedPosition | null => {
  const linked = _.find(
    Coordenates.getLinkedCoordenates(),
    (link: LinkedPosition) => link.from === index
  );
  return linked ? linked : null;
};

const getStart = (index: number): Position | null => {
  return _.get(Coordenates.getStartCoordenates(), index, null);
};

const getFinalPosition = (index: number) => {
  const linkedPosition = getLinked(index);
  return linkedPosition ? get(linkedPosition.to) : get(index);
};

const getPositionNumber = (position: Position): number => {
  const index = _.findIndex(Coordenates.getAllCoordenates(), function (o) {
    return o.x === position.x && o.y === position.y;
  });
  return index;
};

export default {
  getAll,
  get,
  getFirst,
  getLast,
  getLinked,
  getStart,
  getFinalPosition,
  getPositionNumber,
};
